import {createAction} from '@reduxjs/toolkit'

export const paymentMethodSelected = createAction<string>('PAYMENT_METHOD_SELECTED')

export const placeOrderButtonClicked = createAction('PLACE_ORDER_BUTTON_CLICKED')
